import { frontendURL } from "../../../../helper/URLHelper";
import AiRoutingIndex from "./Index.vue";
import SettingsWrapper from "../SettingsWrapper.vue";

export default {
  routes: [
    {
      path: frontendURL("accounts/:accountId/settings/ai-routing"),
      component: SettingsWrapper,
      children: [
        {
          path: "",
          name: "settings_ai_routing",
          component: AiRoutingIndex,
          meta: {
            permissions: ["administrator"],
          },
        },
      ],
    },
  ],
};